var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.dwgFileName,"fixed":"","left-arrow":_vm.hasLeft},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"setting-o","color":"#464646","size":"20"},on:{"click":function($event){return _vm.openOther('set')}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }